module.exports = __webpack_public_path__ + "img/pdf.2e97dc7a.png";